/*
  モバイルスライダーとズーム機能
  DOMContentLoadedイベントで初期化され、data-hero-gallery属性を持つ要素に対して以下の機能を提供します：
  
  1. 画面幅が749px以下の場合、Swiperライブラリを使用してモバイル用のスライダーを初期化
  2. ページネーション機能付きで、1枚ずつスライド表示
  3. 画像へのマウスオーバー時に1.5倍のズーム効果を実装
  4. マウスの位置に応じて、ズームの中心点が動的に変化
  5. ウィンドウリサイズ時に機能を再初期化（デバウンス処理付き）
*/
document.addEventListener('DOMContentLoaded', function () {
  const mobileHeroGalleryList = document.querySelectorAll('[data-hero-gallery]');
  mobileHeroGalleryList.forEach((gallery) => {
    const swiperElem = gallery.querySelector('.swiper');
    let swiper = null;

    const initSlider = () => {
      if (window.innerWidth <= 749) {
        if (!swiper) {
          swiper = new Swiper(swiperElem, {
            pagination: {
              el: '.swiper-pagination',
              type: 'fraction',
            },
            slidesPerView: 1,
            spaceBetween: 10,
          });
        }
      } else {
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      }
    };

    // Initial check
    initSlider();

    // Re-init on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initSlider();
      }, 250);
    });
  });

  // Mouseover effect
  const heroGalleryImages = document.querySelectorAll('.product-hero-gallery .hero-gallery-image');

  heroGalleryImages.forEach((image) => {
    image.addEventListener('mousemove', (e) => {
      const figure = image.querySelector('figure');
      const img = figure.querySelector('img');

      const rect = image.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;

      // Apply zoom effect
      img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
      img.style.transform = 'scale(1.5)';
    });

    image.addEventListener('mouseleave', (e) => {
      const img = image.querySelector('img');
      img.style.transform = 'none';
    });
  });
});

/*
  バリアント切り替え機能
  variantChangeカスタムイベントをリッスンし：
  1. すべてのdata-hero-gallery要素を一旦非表示に
  2. 選択されたバリアント（option1）に対応するギャラリーのみを表示
  3. この実装は、レスポンシブデザインを考慮しており、モバイルデバイスでは スワイプ可能なギャラリー、デスクトップでは インタラクティブなズーム機能を提供する効率的な設計となっています。
*/
document.addEventListener('variantChange', function (event) {
  const colorGalleryList = document.querySelectorAll('[data-hero-gallery]');
  if (colorGalleryList.length > 0) {
    colorGalleryList.forEach((item) => {
      item.setAttribute('hidden', true);
    });
    const variantColorGallery = document.querySelector(
      `[data-hero-gallery="${event.detail.variant.option1}"]`,
    );
    variantColorGallery.removeAttribute('hidden');
  }

  if (window.only_color_list) {
    const onlyColorList = window.only_color_list;
    const limitVariationCategoryList = document.querySelectorAll('[data-limit-variation]');
    limitVariationCategoryList.forEach((item) => {
      item.setAttribute('hidden', true);
      const limitType = item.getAttribute('data-limit-variation');

      // Variant変更時、限定ラベルのリストを検索し一致する場合はラベル表示
      const variant = event.detail.variant;
      const variantColorLabel = onlyColorList.find(
        (colorLabel) => colorLabel.indexOf(variant.id) > -1,
      );
      if (variantColorLabel && variantColorLabel.indexOf(limitType) > -1) {
        item.removeAttribute('hidden');
      }
    });
  }
});

/*
  製品の詳細 ドロワー
*/
const initProductDetailsDrawer = () => {
  const drawerOpenerList = document.querySelectorAll('[data-product-details-drawer-opener]');
  const drawer = document.querySelector('#product-details-drawer');

  if (!drawer || !drawerOpenerList.length) return;

  let currentActiveButton = null;
  // ドロワー内スクロール処理
  const scrollToSection = (sectionId) => {
    const targetSection = document.getElementById(sectionId);
    if (!targetSection) return;

    setTimeout(() => {
      aside.scroll({
        top: targetSection.offsetTop,
        behavior: 'smooth',
      });

      const acc = targetSection.querySelector('.accordion');
      if (acc && acc.getAttribute('aria-expanded') === 'false') {
        acc.click();
      }
    }, 300);
  };

  // ドロワーを開く
  drawerOpenerList.forEach((opener) => {
    opener.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.classList.add('is-active');
      document.body.classList.add('no-scroll');
    });
  });

  // ドロワーを閉じる
  const closeBtnList = drawer.querySelectorAll(
    '.product-details-drawer__close-button,.product-details-drawer__bg',
  );
  const closeDrawer = () => {
    drawer.classList.remove('is-active');
    document.body.classList.remove('no-scroll');
  };

  closeBtnList.forEach((closeBtn) => {
    closeBtn.addEventListener('click', closeDrawer);
  });

  const aside = drawer.querySelector('.product-details-drawer__aside');
  const sections = drawer.querySelectorAll('section[id]');

  const observerOptions = {
    root: aside,
    threshold: 0,
    rootMargin: '-10px 0px -90% 0px',
  };

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      // 上部が表示エリアに入った最後のセクションをアクティブにする
      if (entry.isIntersecting) {
        const sectionId = entry.target.id;
        const menuButton = drawer.querySelector(
          `.product-details-drawer__menu-button[data-target="${sectionId}"]`,
        );

        if (currentActiveButton && currentActiveButton !== menuButton) {
          currentActiveButton.classList.remove('active');
        }

        menuButton.classList.add('active');
        currentActiveButton = menuButton;
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  sections.forEach((section) => observer.observe(section));

  const menuButtons = drawer.querySelectorAll('.product-details-drawer__menu-button[data-target]');
  menuButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const sectionId = button.getAttribute('data-target');
      scrollToSection(sectionId, button);
    });
  });

  // アコーディオン表示
  const accordionButtons = drawer.querySelectorAll('.accordion');
  accordionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const activeSection = button.closest('.product-details-drawer__aside-section');
      const preActiveButton = drawer.querySelector('.accordion[aria-expanded="true"]');
      const preActiveSection = drawer.querySelector(
        '.product-details-drawer__aside-section.active',
      );

      if (preActiveSection?.id === activeSection?.id) {
        button.setAttribute('aria-expanded', false);
        activeSection.classList.remove('active');
      } else {
        if (preActiveButton) {
          preActiveButton.setAttribute('aria-expanded', false);
        }
        if (preActiveSection) {
          preActiveSection.classList.remove('active');
        }

        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', !isExpanded);
        if (!isExpanded) {
          button.closest('.product-details-drawer__aside-section').classList.add('active');
        } else {
          button.closest('.product-details-drawer__aside-section').classList.remove('active');
        }
      }
    });
  });

  // レビューを見るボタン
  const reviewOpener = document.querySelector('[data-review-opener]');
  if (reviewOpener) {
    reviewOpener.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.classList.add('is-active');
      document.body.classList.add('no-scroll');
      scrollToSection('reviews');
    });

    // URLパラメータで"?review="open"が指定されている場合、レビューを開く
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('review') === 'open') {
      drawer.classList.add('is-active');
      document.body.classList.add('no-scroll');
      scrollToSection('reviews');
    }
  }

  // LEEEPのレビューリンク（a.LRSDLink / a.RSDLink）クリックで reviews へ誘導
  // ※ LEEEPは後からDOMに挿入されることがあるので event delegation を採用
  if (!window.__leeepReviewHooked) {
    window.__leeepReviewHooked = true;

    document.addEventListener(
      'click',
      (e) => {
        const link = e.target.closest('a.LRSDLink, a.RSDLink');
        if (!link) return;

        e.preventDefault();
        e.stopPropagation();

        drawer.classList.add('is-active');
        document.body.classList.add('no-scroll');
        scrollToSection('reviews');
      },
      true,
    );
  }
};
document.addEventListener('DOMContentLoaded', initProductDetailsDrawer);

/*
  サイズチャート ドロワー
*/
const initSizeChartPopup = () => {
  const popupOpenerList = document.querySelectorAll('[data-size-chart-popup-opener]');
  const popup = document.querySelector('#product-size-chart-popup');

  if (!popup || !popupOpenerList.length) return;

  // ドロワーを開く
  popupOpenerList.forEach((opener) => {
    opener.addEventListener('click', (e) => {
      e.preventDefault();
      popup.classList.add('is-active');
      document.body.classList.add('no-scroll');
    });
  });

  // ドロワーを閉じる
  const closeBtnList = popup.querySelectorAll(
    '.product-size-chart-popup__close-button,.product-size-chart-popup__bg',
  );
  const closePopup = () => {
    popup.classList.remove('is-active');
    document.body.classList.remove('no-scroll');
  };

  closeBtnList.forEach((closeBtn) => {
    closeBtn.addEventListener('click', closePopup);
  });

  const calcPopupHeaderHeight = () => {
    const popupHeaderHeight = popup.querySelector('.product-size-chart-popup__header').offsetHeight;

    popup.style.setProperty('--popup-header-height', `${popupHeaderHeight}px`);
  };
  calcPopupHeaderHeight();

  window.addEventListener('resize', () => {
    calcPopupHeaderHeight();
  });
};
document.addEventListener('DOMContentLoaded', initSizeChartPopup);
